import { LoaderMessage } from "../components/loaderMessage/loaderMessage";
import NoData from "../components/noData/noData";
import { useEligibilityDetail } from "../hooks/useEligibilityDetail";
import { EligibilityDetailProvider } from "../views/SinglePatientEligibilityDetailsView/EligibilityDetailContext";
import SinglePatientEligibilityDetailsView from "../views/SinglePatientEligibilityDetailsView";
import { useParams } from "react-router-dom";
import { NO_DATA_FOUND_MESSAGE } from "../utils/apiErrorMessage";

/**
 * Page route for the single-patient eligibility details screen.
 *
 * First paint loads only `GET /eligibility/{trialId}/{mrn}/detail`. That
 * payload already includes overrides, so `/overrides` is not called here.
 *
 * @returns The eligibility details view, or a loading/error state
 */
const SinglePatientEligibilityDetails = () => {
  const { trialId = "", mrn = "" } = useParams();
  const { detail, loading, error, refresh } = useEligibilityDetail(trialId, mrn);

  if (loading) {
    return (
      <div className="flex h-full min-h-0 flex-col p-3 bg-white">
        <LoaderMessage message="Fetching eligibility details ..." />
      </div>
    );
  }

  if (error || !detail) {
    return (
      <div className="flex h-full min-h-0 flex-col p-3 bg-white">
        <NoData text={error || NO_DATA_FOUND_MESSAGE} />
      </div>
    );
  }

  return (
    <EligibilityDetailProvider
      detail={detail}
      trialId={trialId}
      mrn={mrn}
      refreshDetail={refresh}
    >
      <div className="h-full min-h-0">
        <SinglePatientEligibilityDetailsView />
      </div>
    </EligibilityDetailProvider>
  );
};

export default SinglePatientEligibilityDetails;
